import { render } from "./AcquisitionCreate.vue?vue&type=template&id=4c5e6496&scoped=true"
import script from "./AcquisitionCreate.vue?vue&type=script&lang=js"
export * from "./AcquisitionCreate.vue?vue&type=script&lang=js"

import "./AcquisitionCreate.vue?vue&type=style&index=0&id=4c5e6496&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5e6496"]])

export default __exports__